import Router from "next/router";

import type { LinkOptions, LinkPressEvent, LinkResult } from "../link";
import { isNoopHref } from "./guards";

export const useLink = ({
  href,
  replace,
  scroll,
  shallow,
}: LinkOptions): LinkResult => ({
  accessibilityRole: "link",
  href,
  onPress: event => {
    if (!claimClick(event) || isNoopHref(href)) {
      return;
    }
    const navigate = replace ? Router.replace : Router.push;
    void navigate(href, undefined, { shallow, scroll });
  },
});

const claimClick = (event: LinkPressEvent | undefined): boolean => {
  if (event === undefined) {
    return true;
  }
  const modified =
    "metaKey" in event &&
    (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
  const button = "button" in event ? event.button : undefined;
  if (
    event.defaultPrevented ||
    modified ||
    (button !== undefined && button !== 0) ||
    !isSelfTarget(event.currentTarget)
  ) {
    return false;
  }
  event.preventDefault();
  return true;
};

const isSelfTarget = (currentTarget: unknown): boolean => {
  const target =
    typeof currentTarget === "object" &&
    currentTarget !== null &&
    "target" in currentTarget
      ? currentTarget.target
      : undefined;
  return (
    target === undefined ||
    target === null ||
    target === "" ||
    target === "self"
  );
};
